var selectors = {
  themeOverlay: '[data-overlay]'
};
var classes = {
  overlayOpacity: 'tw-opacity-0',
  hidden: 'tw-hidden'
};
var overlay = document.querySelector(selectors.themeOverlay);
export var fadeInOverlay = function fadeInOverlay() {
  overlay.classList.remove(classes.hidden);
  setTimeout(function () {
    overlay.classList.remove(classes.overlayOpacity);
  }, 100);
};
export var fadeOutOverlay = function fadeOutOverlay() {
  overlay.classList.add(classes.overlayOpacity);
  setTimeout(function () {
    overlay.classList.add(classes.hidden);
  }, 100);
};
export var scrollLock = function scrollLock() {
  var mobileOverflow = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  document.documentElement.style.overflow = 'hidden';
  document.body.scroll = 'no';

  if (mobileOverflow === 1 && window.innerWidth < 640) {
    document.body.style.overflow = 'hidden';
  }
};
export var scrollUnlock = function scrollUnlock() {
  var mobileOverflow = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  document.documentElement.style.overflow = '';
  document.body.scroll = '';

  if (mobileOverflow === 1 && window.innerWidth < 640) {
    document.body.style.overflow = '';
  }
};
/* Based on the prepareTransition by Jonathan Snook */

/* Jonathan Snook - MIT License - https://github.com/snookca/prepareTransition */

export var prepareTransition = function prepareTransition(element) {
  element.addEventListener('transitionend', function (event) {
    event.currentTarget.classList.remove('is-transitioning');
  }, {
    once: true
  });
  var properties = ['transition-duration', '-moz-transition-duration', '-webkit-transition-duration', '-o-transition-duration'];
  var duration = 0;
  properties.forEach(function (property) {
    var computedValue = getComputedStyle(element)[property];

    if (computedValue) {
      computedValue.replace(/\D/g, '');
      duration || (duration = parseFloat(computedValue));
    }
  });

  if (duration !== 0) {
    element.classList.add('is-transitioning');
    element.offsetWidth;
  }
};